import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import './index.scss';

const toLinkFunc = () => {
  window.close();
};

const BackLpButton = ({ label, onClick, link = '', valid = true }) => {
  return (
    <Link
      to={link}
      className={clsx('BackLpButton')}
      onClick={toLinkFunc}
    >
      <button
        className="button"
        type="button"
        onClick={valid ? onClick : () => { console.log('no valid'); }}
      >
        {label}
      </button>
    </Link>
  );
};

export default BackLpButton;